import React, { Dispatch, SetStateAction } from 'react';
import { Dialog, DialogContent } from '@/components/shadcn/dialog';
import CloseIcon from '../../icons/CloseIcon';

interface Props {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  hideCloseButton?: boolean;
  fullScreen?: boolean;
  children: any;
}

const Modal: React.FC<Props> = ({
  showModal,
  setShowModal,
  hideCloseButton = false,
  fullScreen,
  children,
}) => {
  return (
    <Dialog open={showModal}>
      <DialogContent
        data-fullscreen={fullScreen}
        className="data-[fullscreen=true]:h-dvh data-[fullscreen=true]:max-w-full data-[fullscreen=true]:p-0">
        {!hideCloseButton && (
          <div
            onClick={() => {
              setShowModal(false);
            }}
            className="absolute right-5 top-5 z-50 flex cursor-pointer items-center">
            <CloseIcon className="fill-neutral-0" />
          </div>
        )}
        <div className="relative">{children}</div>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
